const __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/pro-solid-svg-icons/faMinus");